import { render, staticRenderFns } from "./Slices.vue?vue&type=template&id=547eff65&"
import script from "./Slices.vue?vue&type=script&lang=js&"
export * from "./Slices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports